import {Injectable} from '@angular/core';
import {RoleIdSubProjectIdManagerUserId} from '../../models';
import {KluhManagerValidator} from '../../validators/kluh-manager-validator';
import {BaseIAMDao} from '../../base-iam-dao';
import {R2CloudHttpApiService} from '../../r2-cloud-http-api.service';

@Injectable({
  providedIn: 'root'
})
export class RoleSubProjectManagerUserDAOService extends BaseIAMDao<RoleIdSubProjectIdManagerUserId> {
    constructor(http: R2CloudHttpApiService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'role-sub-project-manager-user');
    }
}
